import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation('notFound');

  return (
    <section className="flex flex-col items-center justify-center px-6 py-24 md:py-40 text-center">
      <span className="font-sans text-sm uppercase tracking-widest text-tertiary opacity-80 mb-4">
        404
      </span>
      <h1 className="font-serif text-display-sm md:text-display-lg text-on-surface tracking-tight mb-6">
        {t('heading')}
      </h1>
      <p className="font-sans text-body-lg text-on-surface-variant opacity-80 max-w-md mb-10">
        {t('description')}
      </p>
      <Link
        to="/"
        className="inline-flex items-center justify-center px-8 py-3 rounded-full bg-btn-primary text-btn-primary-text font-sans text-sm font-medium tracking-wide transition-transform hover:scale-[1.02] focus-visible:ring-2 focus-visible:ring-tertiary focus-visible:ring-offset-2 focus-visible:outline-none"
      >
        {t('backHome')}
      </Link>
    </section>
  );
}
